import { chain } from 'lodash';
import { ReportingLoaderBaseConfig } from '../../../base';
import { ReportOverviewLoader } from './reportOverviewInterface';
import { assert } from '@varos/util-typescript';

export function createReportOverviewLoader(
    config: ReportingLoaderBaseConfig
): ReportOverviewLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            const reportQuery = repository.research.report.useFind(
                context,
                {},
                { suspense: true }
            );
            assert(reportQuery.status === 'success', 'expected suspense');
            return {
                reports: chain(reportQuery.data)
                    .map((report) => ({
                        root: report,
                        author: {
                            id: '1',
                            name: 'Agent Susie',
                        },
                    }))
                    .orderBy((report) => report.root.id, 'desc')
                    .value(),
                // reports: [
                //     {
                //         report: fixture.MaintenanceReport.report,
                //         author: fixture.MaintenanceReport.author,
                //         content: fixture.MaintenanceReport.content,
                //     },
                //     {
                //         report: fixture.AutomatingKYC.report,
                //         author: fixture.AutomatingKYC.author,
                //         content: fixture.AutomatingKYC.content,
                //     },
                // ],
            };
        },
    };
}
